import * as React from 'react'

import * as icons from './icons'

export type IconType = typeof icons
export type IconName = keyof IconType
export const Icons: { [key in IconName]: key } = Object.keys(icons).reduce(
  (r, k) => ({ ...r, [k]: k }),
  {} as { [key in IconName]: key }
)

const extractedSpriteMap = false
const spritePublicPath = process.env.ASSET_PREFIX || ''

export type IconProps = {
  icon: IconName
  className?: string
  preserveAspectRatio?: string
}

const Icon: React.FC<IconProps> = ({
  icon,
  className,
  preserveAspectRatio,
}) => {
  const { viewBox, id } = icons[icon]
  const symbolId = id?.replace('-usage', '') ?? ''

  return (
    <span className={className}>
      <svg viewBox={viewBox} preserveAspectRatio={preserveAspectRatio}>
        {extractedSpriteMap ? (
          <use
            xlinkHref={`${spritePublicPath}/sprites/spritemap.svg#${symbolId}`}
            href={`${spritePublicPath}/sprites/spritemap.svg#${symbolId}`}
          />
        ) : (
          <use xlinkHref={`#${symbolId}`} />
        )}
      </svg>
    </span>
  )
}

export default Icon
